import { RiskMatrixDefinition } from 'app/area/case/types-store';
import { matrixRowHeight, RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import {
  getAxisDescription, mapToRiskMatrixPredefinedValues
} from 'app/area/risk-matrix-administration/mappers/map-to-risk-matrix-definition';
import { RiskMatrixAxes } from 'app/area/risk-matrix-administration/types-store';
import { AxisLabelMode, RiskMatrix } from 'app/components/risk-matrix';
import { ComplexValue } from 'app/types-shared';
import React from 'react';

interface MatrixProps {
  onSelectedCell: (xAxisItemIndex: number, yAxisItemIndex: number) => void;
  axes: RiskMatrixAxes;
  translation: RiskMatrixTranslation;
  thirdAxisItem?: ComplexValue<number>;
  riskMatrixDefinition: RiskMatrixDefinition;
}

export const Matrix = ({ axes, riskMatrixDefinition, translation, onSelectedCell, thirdAxisItem }: MatrixProps) => {

  return <RiskMatrix
    className={undefined}
    componentId="risk_matrix"
    onSelectedXChanged={undefined}
    onSelectedYChanged={undefined}
    onSelectedCell={onSelectedCell}
    optionToCellValue={undefined}
    preselectedValues={mapToRiskMatrixPredefinedValues(thirdAxisItem)}
    displayAllValues={true}
    readOnly={false}
    riskMatrixDefinition={riskMatrixDefinition}
    xAxisLabelMode={AxisLabelMode.all}
    yAxisLabelMode={AxisLabelMode.all}
    textXAxisTitle={getAxisDescription(axes[0]?.codetableId, translation)}
    textYAxisTitle={getAxisDescription(axes[1]?.codetableId, translation)}
    label={{ visible: false }}
    rowHeight={matrixRowHeight}
  />;
};
